import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

// FETCH REPORT JOBS
export const fetchReports = createAsyncThunk(
  "reports/fetchReports",
  async (
    { page = 1, filters = [], sortModel = [] } = {},
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().reports;
      const { pageSize } = state;

      const params = new URLSearchParams();
      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.REPORTS}?${params.toString()}`
      );

      console.log("Fetched reports:", response.data);

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// CREATE REPORT JOB AND DOWNLOAD
export const createReportJob = createAsyncThunk(
  "reports/createReportJob",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient.post(ENDPOINTS.REPORTS, payload, {
        responseType: "blob",
      });

      let filename = "report.csv";
      const contentDisposition = response.headers["content-disposition"];
      const match = contentDisposition?.match(/filename="?([^"]+)"?/);
      if (match?.[1]) filename = match[1];

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showNotification({
          message: `Report "${filename}" downloaded successfully.`,
          type: "success",
        })
      );
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to generate report";
      dispatch(showNotification({ message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);
